import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import ErrorBoundary from "@/components/ErrorBoundary";
import PartnerPage from "@/pages/PartnerPage";
import HomePage from "@/pages/HomePage";
import StaticPage from "@/pages/StaticPage";
import LoginPage from "@/pages/LoginPage";
import SignupPage from "@/pages/SignupPage";
import AuthCallback from "@/pages/AuthCallback";
import BlogIndexPage from "@/pages/BlogIndexPage";
import BlogPostPage from "@/pages/BlogPostPage";
import SharedSessionPage from "@/pages/SharedSessionPage";
import DeleteAccountPage from "@/pages/DeleteAccountPage";
import {
    AdminDashboardPage,
    AdminBlogListPage,
    AdminBlogEditPage,
    AdminShareReportsPage,
    AdminFlagsPage,
} from "@/pages/AdminPages";
import { GeoProvider } from "@/context/GeoContext";
import { AuthProvider } from "@/context/AuthContext";

// Phase 8M.7 — legacy /chat/share/:token links are redirected to the
// canonical /share/:token path. The redirect preserves the token segment
// so already-issued links (App Store metadata, social shares, etc.)
// continue to work without a flash of 404. `replace` keeps the back
// button pointing at the previous page, not at the old URL.
function LegacyShareRedirect() {
    const { token } = useParams();
    return <Navigate to={`/share/${token}`} replace />;
}

function App() {
    return (
        <ErrorBoundary>
            <AuthProvider>
                <GeoProvider>
                    <div className="App">
                        <BrowserRouter>
                            <Routes>
                                <Route path="/" element={<HomePage />} />
                                <Route path="/partner" element={<PartnerPage />} />
                                <Route path="/login" element={<LoginPage />} />
                                <Route path="/signup" element={<SignupPage />} />
                                <Route path="/auth/callback" element={<AuthCallback />} />
                                <Route path="/share/:token" element={<SharedSessionPage />} />
                                <Route path="/chat/share/:token" element={<LegacyShareRedirect />} />
                                <Route path="/about" element={<StaticPage path="/about" />} />
                                <Route path="/faq" element={<StaticPage path="/faq" />} />
                                <Route path="/terms" element={<StaticPage path="/terms" />} />
                                <Route path="/privacy" element={<StaticPage path="/privacy" />} />
                                <Route path="/contact" element={<StaticPage path="/contact" />} />
                                <Route path="/delete-account" element={<DeleteAccountPage />} />
                                <Route path="/blog" element={<BlogIndexPage />} />
                                <Route path="/blog/:slug" element={<BlogPostPage />} />
                                <Route path="/admin" element={<AdminDashboardPage />} />
                                <Route path="/admin/blog" element={<AdminBlogListPage />} />
                                <Route path="/admin/blog/new" element={<AdminBlogEditPage />} />
                                <Route path="/admin/blog/:id/edit" element={<AdminBlogEditPage />} />
                                <Route path="/admin/reports" element={<AdminShareReportsPage />} />
                                <Route path="/admin/flags" element={<AdminFlagsPage />} />
                            </Routes>
                        </BrowserRouter>
                    </div>
                </GeoProvider>
            </AuthProvider>
        </ErrorBoundary>
    );
}

export default App;
